<template>
  <b-modal
      id="fba-barcode-modal"
      ref="fba-barcode-modal"
      hide-footer
      hide-header
      size="lg"
      @hidden="handHiden"
      @shown="handShown"
  >
    <b-button class="pull-right" variant="success" @click="print">Yazdır</b-button>
    <div id="printArea" class="fba-barcode-print">
        <div class="book"
            v-for="(selectedBasketitem, index) in printableBasketItems"
            :key="`${selectedBasketitem.id}-${index}`"
        >
            <div class="page">
                <div class="subpage">
                    <div class="productBarcode">
                        <VueBarcode
                            :value="selectedBasketitem.fn_sku"
                            format="CODE128"
                            height="50"
                            width="1"
                            marginTop="1"
                            marginBottom="1"
                            fontOptions="bold"
                            font-size="10"
                        />
                    </div>
                    <div class="productDetail">
                        <div class="productName">{{ selectedBasketitem.product.name }}</div>
                        <div class="productMetaBarcode">
                            {{ selectedBasketitem.product.barcode }} - {{ selectedBasketitem.az_product.merchant_sku }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <b-button class="pull-right" variant="success" @click="print">Yazdır</b-button>
  </b-modal>
    </template>

<script>
import { mapGetters } from 'vuex';
import VueBarcode from 'vue-barcode';
export default {
    name: 'FbaBarcode',
    components: {
        VueBarcode
    },
    computed: {
       ...mapGetters('azFbaBasket', ['_baskets', '_selectedBasketitems']),
       printableBasketItems() {
           return this._baskets.reduce((items, selectedBasketitem) => {
               if (!this._selectedBasketitems.includes(selectedBasketitem.id)) {
                   return items;
               }

               const amount = Number(selectedBasketitem.amount) || 0;

               for (let index = 0; index < amount; index += 1) {
                   items.push(selectedBasketitem);
               }

               return items;
           }, []);
       },
    },
    methods: {
        handHiden() {
            this.$store.commit('azFbaBasket/setSelectedBasketitems', [])
        },
        async handShown() {
            await this.$htmlToPaper('printArea', {
                name: 'etiket',
                specs: ['fullscreen=no', 'titlebar=no', 'scrollbars=yes',],
                styles: ['/etiketfba.css',],
                timeout: 1000, // default timeout before the print window appears
                autoClose: true, // if false, the window will not close after printing
                windowTitle: window.document.title, // override the window title
            });
        },
        async print() {
            await this.$htmlToPaper('printArea', {
                name: 'etiket',
                specs: ['fullscreen=no', 'titlebar=no', 'scrollbars=yes',],
                styles: ['/etiketfba.css',],
                timeout: 1000, // default timeout before the print window appears
                autoClose: true, // if false, the window will not close after printing
                windowTitle: window.document.title, // override the window title
            });
        }
    }
}

</script>
